import React from "react";

const PrivacyPolicy = () => {

    return (
     <div className={"card"}>
         <div className={"card-title"} >
               <h1 className="title is-2" > <center> Privacy policy </center> </h1>
         </div>

     </div>
    );
}

export default PrivacyPolicy;
